import { useMutation } from "@apollo/client";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  Card,
  FlatActionList,
  Page,
  Text,
} from "@towersystems/roam-common-native";
import { Terminal } from "@towersystems/roam-common/lib/generated-types";
import { useEffect, useState } from "react";
import { View } from "react-native-ui-lib";
import { TerminalSettingsRootParamList } from "../../../../types";
import ReceiptTemplate from "../../../../utilities/data/model/ReceiptTemplate";
import { useTerminalModelContextProvider } from "../../../../utilities/terminal";
import { MUTATION_UPDATE_TERMINAL } from "../../../../utilities/terminal/constants";

export type PrintReceiptModalScreenProps = NativeStackScreenProps<
  TerminalSettingsRootParamList,
  "SelectTerminalReceiptTemplateScreen"
>;

export const SelectTerminalReceiptTemplateScreen = ({
  navigation,
}: PrintReceiptModalScreenProps) => {
  const { terminal } = useTerminalModelContextProvider();

  const [receiptTemplates, setReceiptTemplates] = useState<
    ReceiptTemplate[] | undefined
  >();

  const [f] = useMutation<{ updateTerminal: Terminal }>(
    MUTATION_UPDATE_TERMINAL
  );

  const database = useDatabase();

  useEffect(() => {
    database
      .get<ReceiptTemplate>("receipt_template")
      .query()
      .fetch()
      .then((i) => setReceiptTemplates(i));
  }, []);

  const handleOnPress = async (receiptTemplate: ReceiptTemplate) => {
    return f({
      variables: {
        input: {
          id: terminal.id,
          defaultReceiptTemplateId: receiptTemplate.id,
        },
      },
    })
      .then((r) => {
        if (r.data) {
          return database.write(async () => {
            await terminal.update((t) => {
              t.defaultReceiptTemplate.id =
                r.data?.updateTerminal.defaultReceiptTemplateId;
            });
          });
        }
      })
      .then(() => navigation.goBack())
      .catch(console.log);
  };

  const items =
    receiptTemplates?.map((i) => {
      const selected = i.id == terminal.defaultReceiptTemplate.id;
      return {
        key: i.id,
        title: i.name,
        subTitle: i.receiptTemplateType.id,
        onPress: () => handleOnPress(i),
        selected,
      };
    }) || [];

  const noContentMarkup =
    receiptTemplates !== undefined && receiptTemplates.length == 0 ? (
      <Text>No receipt templates found</Text>
    ) : undefined;

  return (
    <Page>
      <View>
        {noContentMarkup}
        {items.length > 0 && (
          <Card>
            <FlatActionList items={items} />
          </Card>
        )}
      </View>
    </Page>
  );
};
